import React, { useEffect, useState } from 'react'
import AddIssueDynemicForm from '../../Services/addIssueDynemicFrom';
import Drawer from "react-modern-drawer";
import CustomLogisticsTable from "../../Logistics/CustomLogisticsTable";

import backicon from "../../../../Assets/icons/backIcon.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";
import deleteIcon from "../../../../Assets/icons/trash.svg";

import "react-modern-drawer/dist/index.css";
import axiosInstance from '../../../../http.common';
import DynamicForm from '../../../customformComponent/customForm/DynamicForm';
import SalesDynamicForm from './SalesDynamicform';

const AddVehicleDetails = ({visit_id, isEdit, setIsEdit, isOpen, setIsOpen, vehicleId, VehicleDetailsData }) => {

    const [formData, setFormData] = useState({});
    const [validationErrors,setValidationErrors] = useState({})
    // const [isOpen, setIsOpen] = React.useState(false);
    const [customerId, setCustomerId] = useState([]);
    const [showParentDesignation, setShowParentDesignation] = useState(false);
    const [make, setMake] = useState([]);
    const [model, setModel] = useState([]);
    const [product, setProduct] = useState([]);
    const [subproduct, setSubproduct] = useState([]);
    const [variantDD, setVariantDD] = useState([]);
    const [color, setColor] = useState([]);
    const [fuelType, setFuelType] = useState([]);

    const [ vehicleDetails , setVehicleDetailsData ] = useState([])


    const token = localStorage.getItem("authToken");

    const [physicalStockData, setphysicalStockData] = useState([]);

    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        // fetchDepartments(newPage);
      };

    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState);
        if(isEdit){
          setIsEdit(!isEdit)
        }
        // setFormData({})
        
      };

      useEffect(() => {
        console.log(formData, "FORMDATAVEHICLE")
      },[formData])

      const handleDrawerFormVehicle = async (formData) => {
        console.log("clicked");
        const errors = {};
        let isValid = true;
      
        VehicleDrawerInputs.forEach((field) => {
          if (field.validation && field.validation.required) {
            if (!formData[field.name]) {
              errors[field.name] = "This field is required";
              isValid = false;
            }
          } else if (
            field.required &&
            field.validation &&
            field.validation.pattern &&
            !field.validation.pattern.test(formData[field.name])
          ) {
            errors[field.name] = field.validation.message;
            isValid = false;
          }
        });
      
        if (!isValid) {
          setValidationErrors(errors);
          return;
        }
      
        const formDataObj = new FormData();
        formDataObj.append("business_partner_id", 1);
        formDataObj.append("visit_id", visit_id);
        formDataObj.append("product_id", formData.product_id);
        formDataObj.append("subproduct_id", formData.subproduct_id);
        formDataObj.append("make_id", formData.make_id);
        formDataObj.append("model_id", formData.model_id);
        formDataObj.append("variant_id", formData.variant_id);
        formDataObj.append("color_id", formData.color_id);
        formDataObj.append("fuel_type_id", formData.fuel_type_id);
        formDataObj.append("remark", formData.remark);
        formDataObj.append("is_test_drive", formData.is_test_drive ? 1 : 0);
      
        if (formData.is_test_drive) {
          formDataObj.append("test_drive_assistance_name", formData.test_drive_assistance_name || "");
          formDataObj.append("test_drive_Date", formData.test_drive_Date ? new Date(formData.test_drive_Date).toISOString() : "");
          formDataObj.append("single_img", formData.single_img);
          formDataObj.append("family_img", formData.family_img);
        }
      
        try {
          let response;
      
          if (isEdit) {
            if (formData.is_test_drive) {
              // API call for editing vehicle with file upload (PATCH request)
              response = await axiosInstance.patch(`/salesvisit/updatevisitvehiclewithfile/${vehicleId}`, formDataObj, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${token}`,
                },
              });
            } else {
              // API call for normal case without file upload (PATCH request)
              response = await axiosInstance.patch(
                `/salesvisit/updatecustomervisitvehicle/${vehicleId}`,
                {
                  business_partner_id: 1,
                  visit_id: visit_id,
                  product_id: formData.product_id,
                  subproduct_id: formData.subproduct_id,
                  make_id: formData.make_id,
                  model_id: formData.model_id,
                  variant_id: formData.variant_id,
                  color_id: formData.color_id,
                  fuel_type_id: formData.fuel_type_id,
                  remark: formData.remark,
                  is_test_drive: formData.is_test_drive ? 1 : 0,
                  test_drive_assistance_name: null,
                  test_drive_Date: null,
                  single_img: null,
                  family_img: null,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
            }
          } else if (formData.is_test_drive) {
            // API call for test drive with file upload (POST request)
            response = await axiosInstance.post("/salesvisit/createvisitvehiclewithfile", formDataObj, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            });
          } else {
            // API call for normal case without file upload (POST request)
            response = await axiosInstance.post(
              "/salesvisit/createcustomervisitvehicle",
              {
                business_partner_id: 1,
                visit_id: visit_id,
                product_id: formData.product_id,
                subproduct_id: formData.subproduct_id,
                make_id: formData.make_id,
                model_id: formData.model_id,
                variant_id: formData.variant_id,
                color_id: formData.color_id,
                fuel_type_id: formData.fuel_type_id,
                remark: formData.remark,
                is_test_drive: formData.is_test_drive ? 1 : 0,
                test_drive_assistance_name: null,
                test_drive_Date: null,
                single_img: null,
                family_img: null,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );
          }
      
          if (response.status === 200) {
            toggleDrawer();
            VehicleDetailsData()
          }
      
          console.log(response, "RESPONSEData");
        } catch (error) {
          console.log(error, "Error");
        }
      };
      
      
      useEffect(() => {
        fetchFuelType();
      }, []);
    
      const fetchFuelType = async () => {
        try {
          const business_partner_id = 1;
          const response = await axiosInstance.post(
            "/fueltype/ddlfueltype",
            {
              business_partner_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
    
          const options = response.data.data.data.map((data) => ({
            label: data.NAME,
            value: data.ID,
          }));
    
          setFuelType(options);
          console.log(options, "OPTIONS");
        } catch (error) {
          console.error("Error fetching product options:", error);
        }
      };


      useEffect(() => {
        fetchColorOptions()
      },[])

      const fetchColorOptions = async () => {
        try {
    
          const business_partner_id = 1;
    
          const response = await axiosInstance.post('/color/ddlcolor', {
            business_partner_id
          }, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            }
          });
    
          const options = response.data.data.data.map(color => ({
            label: color.NAME,
            value: color.ID,
          }));
    
          setColor(options);
        } catch (error) {
          console.error('Error fetching color options:', error);
        }
      };

      const VehicleDrawerInputs = [
        {
          name: "product_id",
          label: "Product",
          placeholder: "Select City",
          type: "dropdown",
          options: product,
          required: true,
          gridClass: "col-lg-10",
          validation: { required: true },
        },
        {
          name: "subproduct_id",
          label: "Subproduct Name",
          type: "dropdown",
          options: subproduct,
          gridClass: "col-lg-10",
          required: true,
          validation: { required: true },
        },
        {
          name: "make_id",
          label: "Make",
          placeholder: "Select City",
          type: "dropdown",
          options: make,
          required: true,
          gridClass: "col-lg-10",
          validation: { required: true },
        },
        {
          name: "model_id",
          label: "Model",
          placeholder: "Select ",
          type: "dropdown",
          options: model,
          required: true,
          gridClass: "col-lg-10",
          validation: { required: true },
        },
        {
          name: "variant_id",
          label: "Variant",
          type: "dropdown",
          options: variantDD,
          required: true,
          gridClass: "col-lg-10",
          validation: { required: true },
        },
        {
          name: "color_id",
          label: "Color",
          type: "dropdown",
          options: color,
          required: true,
          gridClass: "col-lg-10",
          validation: { required: true },
        },
        {
          name: "fuel_type_id",
          label: "Fuel Type",
          type: "dropdown",
          options: fuelType,
          required: true,
          gridClass: "col-lg-10",
          validation: { required: true },
        },
        {
          name: "remark",
          label: "Remark",
          type: "text",
          placeholder: "Enter Remark",
          required: true,
          gridClass: "col-lg-10",
          validation: { required: true },
        },

        {
          name: "is_test_drive",
          label: "Test Drive Required",
          type: "toggle",
          required: false,
          options: [{ label: "Extended Warranty", value: 1 }],
          gridClass: "col-lg-10",
        },
        {
            name: "test_drive_assistance_name",
            label: "Test Driver Name",
            type: "text",
            placeholder: "Enter Name",
            required: showParentDesignation ? true:false,
            isVisible: false,
            gridClass: "col-lg-10",
            validation: { required: showParentDesignation ? true:false },
          },
        
        {
          name: "single_img",
          label: "Single Image",
          type: "file",
          required: true,
          gridClass: "col-lg-4",
          required: showParentDesignation ? true:false,
          validation: { required: showParentDesignation ? true:false },
          isVisible: false,
        },
        {
          name: "test_drive_Date",
          label: "Date and Time",
          type: "datetime",
          required: showParentDesignation ? true:false,
          isVisible: false,
          gridClass: "col-lg-10",
          validation: { required: showParentDesignation ? true:false },
        },
        {
          name: "family_img",
          label: "Family Image",
          type: "file",
          required: true,
          gridClass: "col-lg-4",
          required: showParentDesignation ? true:false,
          validation: { required: showParentDesignation ? true:false },
          isVisible: false,
        },
      ];
      


  useEffect(() => {
    // fetchProductDD()
    fetchProductOptions();
  }, []);

  const fetchProductOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/product/ddlproduct",
        {
          business_partner_id: 1
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setProduct(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    const productId = formData.product_id;
    if(productId){
      fetchSubproduct(productId);
      setSubproduct([])
    }
  }, [formData.product_id]);

  const fetchSubproduct = async (productId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/subproduct/ddlsubproduct",
        {
          business_partner_id,
          product_id: productId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setSubproduct(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    const subProductId = formData.subproduct_id;
    const productId = formData.product_id;
    if (subProductId && productId){
      fetchMakeDD(subProductId, productId)
      setMake([])
    }
  },[formData.subproduct_id, formData.product_id])

  const fetchMakeDD = async (productId, subProductId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/make/ddlmake",
        {
          business_partner_id,
          product_id: subProductId,
          subproduct_id: productId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const makedata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setMake(makedata);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    const subProductId = formData.subproduct_id;
    const makeId = formData.make_id;
    const productId = formData.product_id;
    if (productId && makeId && subProductId) {
      fetchModelDD(makeId, productId, subProductId);
      setModel([]);
    }
  }, [formData.make_id, formData.product_id,formData.subproduct_id ]);

  const fetchModelDD = async (makeId, productId, subProductId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/model/ddlmodel",
        {
          business_partner_id,
          product_id: productId,
          make_id: makeId,
          subproduct_id: subProductId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const modeldata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setModel(modeldata);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {

    const subProductId = formData.subproduct_id;
    const makeId = formData.make_id;
    const productId = formData.product_id;
    const modelId = formData.model_id

    if (productId && makeId && subProductId && modelId) {
      fetchVariantDD(makeId, productId, subProductId, modelId);
      setVariantDD([]);
    }

    // fetchVariantDD()
  },[formData.make_id, formData.product_id,formData.subproduct_id,formData.model_id])

  const fetchVariantDD = async (makeId, productId, subProductId, modelId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          business_partner_id,
          product_id: productId,
          make_id: makeId,
          subproduct_id: subProductId,
          model_id:modelId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const variantdata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setVariantDD(variantdata);
    } catch (error) {
      console.log(error, "error");
    }
  };



  // useEffect(() => {
  //   console.log(formData, "FORMDATAStatus")
  //   if(isEdit && formData?.is_test_drive === true){
  //     setShowParentDesignation(true)
  //   }else if (formData?.is_test_drive === 1) {
  //     setShowParentDesignation(true)
  //   }
  // },[formData?.is_test_drive])


  useEffect(() => {
    console.log(formData, "FORMDATAStatus");
  
    if (isEdit) {
      // In edit mode: show inputs only if is_test_drive is 1 or true
      if (formData?.is_test_drive === 1 || formData?.is_test_drive === true) {
        setShowParentDesignation(true);
      } else {
        setShowParentDesignation(false);
      }
    } else {
      // In add mode: show inputs if is_test_drive is true
      if (formData?.is_test_drive === true) {
        setShowParentDesignation(true);
      } else {
        setShowParentDesignation(false);
      }
    }
  
  }, [formData?.is_test_drive, isEdit]);


  useEffect(() => {

      fetchVehicleDataEdit()

  },[vehicleId])


  // const fetchVehicleDataEdit = async () => {
  //   try {
  //   //   const business_partner_id = 1;
  //     const response = await axiosInstance.get(
  //       `/salesvisit/editvisitvehicle/${vehicleId} `,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     const fetchedData = response.data.data[0]
  //     console.log(fetchedData, "FETCHEDDATA")


  //     const formatedData = {
  //       product_id:fetchedData.product_id,
  //       subproduct_id: fetchedData.subproduct_id,
  //       make_id:fetchedData.make_id,
  //       model_id:fetchedData.model_id,
  //       variant_id:fetchedData.variant_id,
  //       color_id:fetchedData.color_id,

  //       fuel_type_id:fetchedData.fuel_type_id,
  //       remark:fetchedData.remark,
  //       test_drive_Date: fetchedData.test_drive_Date,
  //       is_test_drive: fetchedData.is_test_drive,
  //       test_drive_assistance_name:fetchedData.test_drive_assistance_name,
  //       family_img: fetchedData.family_image,
  //       single_img: fetchedData.single_image,

  //     }
  //     setFormData(formatedData)

  //   } catch (error) {
  //     console.error("Error fetching product options:", error);
  //   }
  // };

  const fetchVehicleDataEdit = async () => {
    try {
      const response = await axiosInstance.get(
        `/salesvisit/editvisitvehicle/${vehicleId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const fetchedData = response.data.data[0];
      console.log(fetchedData, "FETCHEDDATA");
  
      const basePath = "http://127.0.0.1:8599/public/upload/";
  
      const formattedData = {
        product_id: fetchedData.product_id,
        subproduct_id: fetchedData.subproduct_id,
        make_id: fetchedData.make_id,
        model_id: fetchedData.model_id,
        variant_id: fetchedData.variant_id,
        color_id: fetchedData.color_id,
        fuel_type_id: fetchedData.fuel_type_id,
        remark: fetchedData.remark,
        test_drive_Date: fetchedData.test_drive_Date,
        is_test_drive: fetchedData.is_test_drive,
        test_drive_assistance_name: fetchedData.test_drive_assistance_name,
  
        // Append base path to the image URLs
        family_img: fetchedData.family_image
          ? `${basePath}${fetchedData.family_image}`
          : "",
        single_img: fetchedData.single_image
          ? `${basePath}${fetchedData.single_image}`
          : "",
      };
  
      setFormData(formattedData);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };
  
  


  return (
    <div>
        <div className='vehcileDetailsTopbar'>
        {/* <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 header-details'>Vehicle Details</h5> */}
        <div className='addVehicle'>
        <div>
              <button className="addcustomerbutton" 
              onClick={() => {
               setFormData({})
               toggleDrawer();
             }}>
               Add Vehicle Details
             </button>
          
          </div>
        </div>
        </div>
        <div style={{ paddingBottom:"30px", paddingLeft:"57px", paddingTop:"15px"}}>
            
        <Drawer
          size={500}
          open={isOpen}
          onClose={toggleDrawer}
          direction="right"
          className="bla bla bla"
        >
          <div style={{ padding: "30px" }}>
            <div style={{display:"flex", justifyContent:"flex-start", alignItems:"center", gap:"15px", }}>
            <div style={{paddingLeft:"45px"}} className="" 
                onClick={()=>toggleDrawer()}>
           <img src={backicon} alt="back" />
            </div>  
            <div>
              <p
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    // paddingLeft: "18px",
                    paddingTop:"15px"
                  }}
                >
                  Add Vehicle Details
                </p>
            </div>
            </div>

            <div>
              {/* <div
                className="d-flex jus align-items-center pt-3 flex-row gap-4"
                style={{ paddingLeft: "20px" }}
              >
                
              </div> */}
             <div style={{ paddingLeft: "20px" }}>
              
                  <div className="mt-3">



                  <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  // marginLeft: "150px",
                }}
              >
                <SalesDynamicForm
                  formConfig={VehicleDrawerInputs}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleDrawerFormVehicle}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  showParentDesignation={showParentDesignation}
                  setShowParentDesignation={setShowParentDesignation}
                />

                <div
                  className="col-12"
                  style={{ display: "flex", alignItems: "center", gap: "10px", paddingLeft:"102px" }}
                >
                  <button
                    onClick={() => handleDrawerFormVehicle(formData)}
                    className="submit-btn p-3"
                    style={{ width: "141px" }}
                  >
                    {"Save"}
                  </button>
                </div>
              </div>
                  </div>
              </div>   
            </div>
          </div>
        </Drawer>
        </div>


    </div>
  )
}

export default AddVehicleDetails